// SCSS
import './stylesheets/bootstrap.scss';

// JS
import './js/bootstrap';


/** WEBPACK FOOTER **
 ** ./common.js
 **/